import { AppState } from "types/app";
import { createSelector } from 'reselect'
import { MANUAL_SIMULATION, END_DIALOG } from "constants/sumilationConstants";
import { GlobalState } from "reducers";

const getApp = ({app}: {app: AppState}) => app
const getFreestyle = ({freestyle}: GlobalState) => freestyle

const getActiveSimulation = createSelector(
  getApp,
  app => app.activeSimulation
)

export const getPosibleDialogTypes = createSelector(
  getActiveSimulation,
  simulation => simulation ?
    Object.keys(simulation.dialogs).reduce<string[]>((acc, item) => [...acc, item], [])
    :
    undefined  
)

export const getShowLevers = createSelector(
  getApp,
  ({activeSimulationType, activeDialogType, afterLeverAnimationProgress, simulationSelectActive, activeSimulation }) => 
    activeSimulationType === MANUAL_SIMULATION 
      && activeDialogType !== END_DIALOG 
      && !simulationSelectActive 
      && activeSimulation
      && activeSimulation!.manual.lever !== 'empty'
      && !afterLeverAnimationProgress
)

export const getTruckSimulations = createSelector(
  getApp,
  app => app.truck ? 
    app.data!.simulations.find(({truck}) => truck === app.truck!.name)
    :
    undefined
)

export const getBoxActiveStep = createSelector(
  getApp,
  app => {
    return app.activeSimulation ?
      app.activeSimulation.controlBox ?
        app.activeSimulation.controlBox.steps[app.activeSimulationStep]
        :
        undefined
      :
      undefined;
  }
)

export const getActiveSteps = createSelector(
  getApp,
  app => {
    const activeDialog = app.activeSimulation ?
      app.activeSimulation.dialogs[app.activeSimulationType!]!.find(item => item.type === app.activeDialogType)!
      :
      null

    return activeDialog ?
      activeDialog.steps ? activeDialog.steps : activeDialog.content
      :
      null
  }
) 

export const getCurrentCounterStep = createSelector(
  getApp,
  ({activeSimulation, activeSimulationStep}) => 
    activeSimulation && activeSimulation.counterSteps ?
      activeSimulation.counterSteps[activeSimulationStep]
      :
      undefined
  
)

export const getActiveItemObject = createSelector(
  getFreestyle,
  ({activeItem, items}) => items.find(item => item.id === activeItem)
)